import type { IQueueFrame } from '@/types'
import { sameQueueFrameIdentity } from '@/helpers/holdUntilReadyPresentation'

/**
 * Frame credited for proof-of-play: pin to the committed on-air surface when
 * `playingFrame` still points at an outgoing/preload clip (e.g. after video→video
 * sticky skip — #1443 / Bugbot).
 */
export function resolveActiveFrameForProofOfPlay(opts: {
  surfaceFrame: IQueueFrame | null | undefined
  playingFrame: IQueueFrame | null | undefined
}): IQueueFrame | null {
  const surfaceFrame = opts.surfaceFrame ?? null
  if (surfaceFrame == null) {
    return null
  }
  const playingFrame = opts.playingFrame ?? null
  if (playingFrame != null && sameQueueFrameIdentity(playingFrame, surfaceFrame)) {
    return playingFrame
  }
  return surfaceFrame
}
